<panel width="400">
	<menu always-visible>
		<menuitem (click)="createOrEditDashboardElement()">{{ 'general.create' | translate }}</menuitem>
	</menu>
	<h1>{{ 'dashboard.dashboards-list' | translate }}</h1>
	<list-view [emptyLabel]="'dashboard.dashboards-list.list-empty-label'" scrollable>
		<header defaultSort="ascending">{{ 'dashboard.dashboards-list.name' | translate }}</header>
		<header>{{ 'dashboard.dashboards-list.type' | translate }}</header>
		<header></header>
		<row *listData="let element from dashboardElements" [highlighted]="selectedDashboardElementId == element.id" (action)="createOrEditDashboardElement(element.id)">
			<column>{{ element.name }}</column>
			<column>{{ 'enum.dashboard-type.' + dashboardType[element.type] | translate }}</column>
			<column align-right><icon [ngClass]="{ 'disabled': !canDeleteDashboardElement(element) }" (click)="$event.stopPropagation(); deleteDashboardElement(element)" type="trash-alt" /></column>
		</row>
	</list-view>
</panel>
